import { Link } from 'react-router-dom';
import { FiArrowRight, FiShield, FiUsers, FiBriefcase } from 'react-icons/fi';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      <div className="container mx-auto px-4 py-16 pb-24">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
            Welcome to{' '}
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">
              DukeHub
            </span>
          </h1>
          <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto">
            Your contractor control panel for managing onboarding, projects, and more.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link
              to="/login"
              className="px-8 py-4 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-2"
            >
              Sign In
              <FiArrowRight className="w-5 h-5" />
            </Link>
            <Link
              to="/register"
              className="px-8 py-4 glass-button text-white font-semibold rounded-xl hover:bg-white/30 transform hover:scale-105 transition-all duration-200"
            >
              Sign Up
            </Link>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mt-20">
            <div className="glass-card p-6">
              <FiShield className="w-12 h-12 text-blue-400 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold text-white mb-2">Secure</h3>
              <p className="text-slate-300">Enterprise-grade security for your data</p>
            </div>
            <div className="glass-card p-6">
              <FiUsers className="w-12 h-12 text-cyan-400 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold text-white mb-2">Collaborative</h3>
              <p className="text-slate-300">Connect with your team seamlessly</p>
            </div>
            <div className="glass-card p-6">
              <FiBriefcase className="w-12 h-12 text-blue-400 mb-4 mx-auto" />
              <h3 className="text-xl font-semibold text-white mb-2">Professional</h3>
              <p className="text-slate-300">Built for contractors and professionals</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
